import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceNameStep } from '@/features/workspace/ui/workspace-name-step';
import { REDIRECT_PAGE } from '@/shared/redirect/constants';
import z from 'zod';

const searchSchema = z.object({
  redirectPage: z.enum(REDIRECT_PAGE).optional(),
});

export const Route = createFileRoute('/workspace/create/name')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <WorkspaceNameStep />;
}
